var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 22,
    viewBox: "0 0 15 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66389 0.992188C6.94392 0.992188 6.25343 1.2782 5.74433 1.7873C5.23523 2.2964 4.94922 2.98689 4.94922 3.70686V10.946C4.94922 11.666 5.23523 12.3565 5.74433 12.8656C6.25343 13.3747 6.94392 13.6607 7.66389 13.6607C8.38387 13.6607 9.07436 13.3747 9.58346 12.8656C10.0926 12.3565 10.3786 11.666 10.3786 10.946V3.70686C10.3786 2.98689 10.0926 2.2964 9.58346 1.7873C9.07436 1.2782 8.38387 0.992188 7.66389 0.992188V0.992188Z",
    stroke: "white",
    strokeWidth: 1.80978,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9976 9.13672V10.9465C13.9976 12.6264 13.3302 14.2376 12.1423 15.4255C10.9544 16.6134 9.34329 17.2807 7.66334 17.2807C5.9834 17.2807 4.37226 16.6134 3.18436 15.4255C1.99646 14.2376 1.3291 12.6264 1.3291 10.9465V9.13672",
    stroke: "white",
    strokeWidth: 1.80978,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66406 17.2812V20.9008",
    stroke: "white",
    strokeWidth: 1.80978,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.04395 20.8984H11.2831",
    stroke: "white",
    strokeWidth: 1.80978,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/MIC.15c455322e6b3c99428aae87f61cce02.svg";
export { ForwardRef as ReactComponent };